import { contrastRatio, HSLColor } from '@yola/yola-palette-generator';
import emitFallbackWarning from './emit-fallback-warning';

const reduceOpacity = ({
  targetColor,
  backgroundColor,
  opacity,
  condition,
  surfaceColor,
  fallback,
}) => {
  const { hue, saturation, lightness } = targetColor;
  const colorInstance = new HSLColor(hue, saturation, lightness, opacity);

  let alpha = colorInstance.getAlpha();

  while (alpha > 0) {
    colorInstance.setAlpha(+alpha.toFixed(2));
    const ratio = contrastRatio(backgroundColor, colorInstance, { surfaceColor });

    if (condition(ratio)) {
      colorInstance.setAlpha(
        colorInstance.alpha < 1
          ? Number.parseFloat((colorInstance.alpha + 0.01).toFixed(2))
          : colorInstance.alpha
      );
      return colorInstance;
    }

    alpha -= 0.01;
  }
  emitFallbackWarning(
    `Cannot reduce an opacity to reach proper contrast ratio between hsl(${targetColor.toColorString()}) and background color hsl(${backgroundColor.toColorString()})`,
    fallback
  );
  return colorInstance;
};

export default reduceOpacity;
